"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CliOptionsConfig = void 0;
const options_1 = require("@ganache/options");
const cli_defaults_1 = require("./cli-defaults");
exports.CliOptionsConfig = new options_1.OptionsConfig(cli_defaults_1.cliDefaults);
//# sourceMappingURL=cli-options-config.js.map